import {
  FETCH_FLASHCARD,
  FETCH_FLASHCARD_BODY,
  FETCH_ALL_FLASHCARDS,
  CREATE_FLASHCARDS,
  DELETE_FLASHCARDS,
  UPDATE_FLASHCARDS,
  UPDATE_FLASHCARD_HEADER,
  FETCH_ALL_FLASHCARD_HEADERS,
} from '../constants/actionTypes';
import * as api from '../api/index.js';

export const getFlashcards = () => async (dispatch) => {
  try {
    const { data } = await api.fetchFlashcards();

    dispatch({ type: FETCH_ALL_FLASHCARDS, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};

export const getFlashcard = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchFlashcard(id);

    dispatch({ type: FETCH_FLASHCARD, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};

export const getFlashcardBody = (id) => async (dispatch) => {
  dispatch({
    type: FETCH_FLASHCARD_BODY,
    payload: { _id: id, source: undefined },
  });
  try {
    const { data } = await api.fetchFlashcardBody(id);

    dispatch({
      type: FETCH_FLASHCARD_BODY,
      payload: { ...data, _id: data._id ?? id },
    });
  } catch (error) {
    console.log(error.message);
  }
};

export const getAllFlashcardHeaders = () => async (dispatch) => {
  try {
    const { data } = await api.fetchFlashcardHeaders();

    dispatch({ type: FETCH_ALL_FLASHCARD_HEADERS, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};

export const createFlashcard = (flashcard) => async (dispatch) => {
  try {
    const { data } = await api.createFlashcard(flashcard);

    dispatch({ type: CREATE_FLASHCARDS, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};

export const deleteFlashcard = (id) => async (dispatch) => {
  try {
    await api.deleteFlashcard(id);

    dispatch({ type: DELETE_FLASHCARDS, payload: id });
    return true;
  } catch (error) {
    console.log(error.message);
    return false;
  }
};

export const updateFlashcard = (id, flashcard) => async (dispatch) => {
  try {
    const { data } = await api.updateFlashcard(id, flashcard);

    dispatch({ type: UPDATE_FLASHCARDS, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};

export const updateFlashcardHeader = (id, header) => async (dispatch) => {
  try {
    const { data } = await api.updateFlashcardHeader(id, header);

    dispatch({ type: UPDATE_FLASHCARD_HEADER, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};
